import React from 'react';
import DGLTH_customer_order from '../components/DGLTH_customer_order';
import DGLTH_supplier_order from '../components/DGLTH_supplier_order';
import DGLTH_invoice from '../module/fatturazione/DGLTH_invoice';
import DGLTH_customer_offer from '../components/DGLTH_customer_offer';
import DGLTH_customer from '../components/DGLTH_customer';
import DGLTH_customer_order_delivery from '../components/DGLTH_customer_order_delivery';



export default function DataGridLastTdHook({ item, props, entity = null, refreshData }) {

    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample':
                            return (
                                <span>Test</span>
                            );
                        case 'customer':
                            return (
                                <>
                                    <DGLTH_customer item={item} props={props} entity={entity} refreshData={refreshData} />
                                </>
                            );
                        case 'gyv_customer_offer':
                            return (
                                <>
                                    <DGLTH_customer_offer item={item} props={props} entity={entity} refreshData={refreshData} />
                                </>
                            );
                        case 'gyv_customer_order':
                            return (
                                <>
                                    <DGLTH_customer_order item={item} props={props} entity={entity} refreshData={refreshData}></DGLTH_customer_order>
                                </>
                            );
                        case 'gyv_supplier_order':
                            return (
                                <>
                                    <DGLTH_supplier_order item={item} props={props} entity={entity} refreshData={refreshData}></DGLTH_supplier_order>
                                </>
                            );
                        case 'gyv_customer_order_delivery':
                            return (
                                <>
                                    <DGLTH_customer_order_delivery item={item} props={props} entity={entity} refreshData={refreshData} />
                                </>
                            );
                        case 'gyv_invoice':
                            return (
                                <>
                                    <DGLTH_invoice item={item} props={props} entity={entity} refreshData={refreshData} />
                                </>
                            );
                        case 'invoice':
                            return (
                                <>
                                    <DGLTH_invoice item={item} props={props} entity={entity} refreshData={refreshData} />
                                </>
                            );
                        default:
                            return (
                                <></>
                            );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
